export default __webpack_public_path__ + "static/media/eye.d0cc314c.svg";